// extracted by mini-css-extract-plugin
export var logo = "_h6-2";
export var logoWrapper = "_h6-1";
export var strip = "_h6-0";